import script from "./ProductionInfoItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionInfoItem.vue?vue&type=script&setup=true&lang=js"

import "./ProductionInfoItem.vue?vue&type=style&index=0&id=d6462888&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6462888"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QAvatar,QImg,QItemLabel});qInstall(script, 'directives', {Ripple});
